import React from 'react'
import "./quote.css";
export default function Quote() {
    return (
        <div className="quote-container">
            <h1 className="quote__title">
                [ Daily = Skill++ ]
            </h1>
            <span className="quote__desc">Quote of the day ✨</span>
        </div>
    )
}
